import { useEffect, useState } from 'react';
import { EscalatorChapter } from './type';
import {
  ActiveChapterState,
  getActiveChapterFromSchedule,
  getMsSinceMidnight,
  getMsUntilNextChapterBoundary,
} from './schedule';

export function useEscalatorSchedule(
  chapters: EscalatorChapter[] | undefined,
  options: { enabled: boolean; previewChapterIndex: number | null },
) {
  const [activeChapter, setActiveChapter] = useState<ActiveChapterState | null>(null);

  useEffect(() => {
    if (!options.enabled || !chapters?.length) {
      setActiveChapter(null);
      return;
    }

    if (options.previewChapterIndex !== null && chapters[options.previewChapterIndex]) {
      setActiveChapter({
        chapterIndex: options.previewChapterIndex,
        chapter: chapters[options.previewChapterIndex],
        elapsedInChapterMs: 0,
      });
      return;
    }

    let timeoutId: ReturnType<typeof setTimeout>;

    const sync = () => {
      const msSinceMidnight = getMsSinceMidnight();
      setActiveChapter(getActiveChapterFromSchedule(chapters, msSinceMidnight));
      timeoutId = setTimeout(sync, getMsUntilNextChapterBoundary(chapters, msSinceMidnight));
    };

    sync();

    return () => clearTimeout(timeoutId);
  }, [chapters, options.enabled, options.previewChapterIndex]);

  return activeChapter;
}
